import {Link} from '@mui/material';

export const getTextWithLink = (text: string, url: string) => {
    const first = text.split('%href_start%');
    const second = first[1].split('%href_end%');
    return (
        <>
            {first[0]}
            <Link href={url} target={'_blank'} rel={'noreferrer'}>
                {second[0]}
            </Link>
            {second[1]}
        </>
    );
};

export const getTextWithLinks = (text: string, urls: string[]) => {
    const parts: React.ReactNode[] = [];
    let urlIndex = 0;
    const textParts = text.split('%href_start%');
    textParts.forEach((part, i) => {
        if (i === 0){
            parts.push(part);
        } else {
            const [linkText, rest] = part.split('%href_end%');
            parts.push(
                <Link 
                    key={urlIndex} 
                    href={urls[urlIndex]}
                    target="_blank"
                    rel="noreferrer"
                >
                    {linkText}
                </Link>
            );
            
            urlIndex++;
            if(rest) parts.push(rest);
        }
    })
    
    return <>{parts}</>;
};
